import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import ptBr from "../../config/texts/pt-br";
import {
  CustomText,
  DefaultLogo,
} from "../../components/index";
import Styles from "./styles";
import { hooks, SessionStorage } from "../../utils";
import { StorageContext } from "../../contexts/StorageContext";

import { api } from "../../services";
import { paths } from "../../navigation/navigate";
import { customModal } from "../../components/modals/utils";
import NewPasswordRegistry from "./components/NewPasswordRegistry";
import { FaKey } from "react-icons/fa6";

import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import Input from "../../components/inputs/newForm/Input";
import InputPassword from "../../components/inputs/newForm/InputPassword";

const loginSchema = z.object({
  username: z.string().min(1, "*Campo Obrigatório").email("E-mail inválido"),
  password: z.string().min(1, "*Campo Obrigatório"),
});
type LoginFormData = z.infer<typeof loginSchema>;

function Login() {
  const texts = ptBr.login;

  const openNewPasswordModal = () => {
    customModal.setInfos(
      "Alteração de Senha",
      [],
      null,
      null,
      <NewPasswordRegistry onSubmit={() => null} />,
      null,
      null,
      <FaKey />
    );
  };

  const navigate = useNavigate();
  const { loading, call } = hooks.useRequest();
  const { setUserData, setIsLogged, addData, logOut } = useContext<any>(StorageContext);

  const { control, handleSubmit } = useForm<LoginFormData>({
    resolver: zodResolver(loginSchema),
  });

  const Submit = async (data: LoginFormData) => {
    const username = data.username.toLocaleLowerCase();
    call(
      null,
      api.getToken({ username, password: data.password }),
      (response) => {
        if (response.ok) {
          call(null, api.getCondominium(), (res) => {
            if (res.ok) {
              addData("condominiumList", res.data);
              SessionStorage.setItem("condominiumList", JSON.stringify(res.data));
              addData("company_type", res.data[0]?.id);
              //SessionStorage.setItem("company_type", res.data[0]?.id);
              setIsLogged(true);
              //SessionStorage.setItem("company_type", data?.company);
              call(null, api.getUserData(), (response) => {
                if (response.ok) {
                  SessionStorage.setItem("userData", response?.data);
                  setUserData(response.data);
                  navigate(paths.myProperties);
                }
              });
            } else {
              logOut();
              customModal.setInfos(
                "Erro",
                [],
                null,
                null,
                <CustomText>{res.message}</CustomText>,
                null,
                null,
                <FaKey />
              );
            }
          });
        }
      }
    );
  };

  return (
    <Styles.ImageBG>
      <Styles.Content>
        <Styles.Header>
          <DefaultLogo maxWidth={200} />
        </Styles.Header>
        <Styles.Title>{texts.title}</Styles.Title>
        <Styles.Subtitle>{texts.subtitle}</Styles.Subtitle>
        <Input
          control={control}
          name="username"
          label={texts.user}
          placeholder="email@exemplo.com.br"
        />
        <InputPassword
          control={control}
          name="password"
          label={texts.password}
          placeholder="Digite sua senha"
        />
        <Styles.ButtonContainer>
          <Styles.ForgotPasswordButton
            onClick={() => navigate(paths.forgetPassword)}
          >
            {texts.forgotPass}
          </Styles.ForgotPasswordButton>
        </Styles.ButtonContainer>
        <Styles.EnterButton
          loading={loading}
          disabled={loading}
          onClick={() => handleSubmit(Submit)()}
          label={texts.enter}
        />
        <CustomText style={{ justifyContent: "center" }}>
          {process.env.REACT_APP_ENV + " v"}
          {process.env.REACT_APP_VERSION}
        </CustomText>
      </Styles.Content>
    </Styles.ImageBG>
  );
}

export default Login;
